<template>
    <div class="my-5" ref="viewContestantGrid">
        <div class="container">
            <ContestantGridHeader
                :contestantGridHeading="contestantGridHeading"
                :contendersList="contendersList"
                :contestNotactiveText="isError ? contestNotactiveText : ''"
                :searchboxText="searchboxText"
                :hideSearchbox="JSON.parse(hideSearchbox.toLowerCase())"
                :hideGreybar="JSON.parse(hideGreybar.toLowerCase())"
                :updatedSearchedContenderList="updatedSearchedContenderList"
                v-on:setSearchResult="setSearchResult($event)"
            />
            <span class="sr-only" tabindex="-1" ref="focus" aria-hidden="true"></span>
            <ContestantGrid
                :search="search"
                :voteNowLabel="voteNowLabel"
                :votesText="votesText"
                :voteText="voteText"
                :contendersList="contendersList"
                :currentPageNo="currentPageNo"
                :showNumberOfContendersPerPage="+pageSize"
                v-on:getPaginationDetails="getPaginationDetails($event)"
                v-on:updatedSearchedResults="updatedSearchedResults($event)"
            />
            <ContestantGridPagination
                v-if="numberOfPagesArray.length >= 2"
                :numberOfPagesArray="numberOfPagesArray"
                :currentPageNo="currentPageNo"
                :contendersList="contendersList"
                :pageSize="+pageSize"
                v-on:setCurrentActivePage="setCurrentActivePage($event)"
            />
        </div>
    </div>
</template>

<script>
import ContestantGridHeader from '@/components/contestant-grid-header.vue';
import ContestantGrid from '@/components/contestant-grid.vue';
import ContestantGridPagination from '@/components/contestant-grid-pagination.vue';

export default {
    name: 'AhaContestantGrid',
    data() {
        return {
            search: '',
            isError: false,
            voteNowLabel: '',
            currentPageNo: 1,
            contendersList: [],
	        numberOfPagesArray: [],
            contestantGridHeading: '',
            updatedSearchedContenderList: [],
        };
    },
    components: {
        ContestantGrid,
        ContestantGridHeader,
        ContestantGridPagination
    },
    props: {
        endpoint: String,
        votesText: String,
        voteText: String,
        hideSearchbox: String,
        contextPageId: String,
        pageSize: String,
        contestNotactiveText: String,
        searchboxText: String,
        hideGreybar: String,
    },
    methods: {
    setSearchResult(value) {
        this.search = value;
    },
    getPaginationDetails(data) {
        this.currentPageNo = data.currentActivePage;
        this.numberOfPagesArray = data.numberOfPagesArray;
    },
    updatedSearchedResults(data) {
        this.updatedSearchedContenderList = data;
    },
    setCurrentActivePage(data) {
        this.currentPageNo = data;
        this.$refs.focus.focus();
        this.$refs.viewContestantGrid.scrollIntoView({ behavior: 'smooth' });
    }
  },
    mounted() {
        fetch(`${this.endpoint}?contextPageId=${this.contextPageId}`).then(res => res.json())
        .then(data => {
            this.isError = false;
            this.contestantGridHeading = data.ContestantGridHeading;
            this.voteNowLabel = data.VoteNowLabel;
            this.contendersList = data.Nominees.map((item) => {
                const nomineeDetails = item;
                nomineeDetails.fullName = `${nomineeDetails.FirstName} ${nomineeDetails.LastName}`;
                return nomineeDetails;
            });
        })
        .catch(() => {
            this.isError = true;
        });
    },
}
</script>



// WEBPACK FOOTER //
// src/app/components/aha-contestant-grid.vue